document.addEventListener("DOMContentLoaded", () => {

  const monthHeading = document.getElementById("calendar-month");
  const calendarGrid = document.getElementById("event-calendar-grid");
  const mobileList = document.getElementById("event-calendar-mobile-list");
  const gameFilter = document.getElementById("game-filter");

  if (!monthHeading || !calendarGrid) return;

  /* ----------------------------------------
     MONTH MAP
  ---------------------------------------- */

  const months = {
    January: 0,
    February: 1,
    March: 2,
    April: 3,
    May: 4,
    June: 5,
    July: 6,
    August: 7,
    September: 8,
    October: 9,
    November: 10,
    December: 11
  };

  const displayMonth = monthHeading.dataset.month;
  const displayYear = parseInt(monthHeading.dataset.year);

  const monthIndex = months[displayMonth];

  let selectedDay = null;

  /* ----------------------------------------
     EVENTS FROM LIQUID
  ---------------------------------------- */

  const eventData = document.getElementById("calendar-events-data");

  let events = [];

  if (eventData) {

    try {

      events = JSON.parse(eventData.textContent);

    }

    catch (error) {

      console.error(error);

    }

  }

  /* ----------------------------------------
     DRAW CALENDAR
  ---------------------------------------- */

  function drawCalendar(selectedGame = "all-games") {

    const firstDay = new Date(displayYear, monthIndex, 1).getDay();

    const daysInMonth = new Date(displayYear, monthIndex + 1, 0).getDate();

    calendarGrid.innerHTML = "";

const totalCells = firstDay + daysInMonth;

let rows = Math.ceil(totalCells / 7);

const totalGridCells = rows * 7;

for (let i = 0; i < totalGridCells; i++) {

  const cell = document.createElement("div");

  cell.className = "event-calendar-day empty";

  cell.innerHTML = `
    <div class="event-calendar-day-number"></div>
    <div class="event-calendar-events"></div>
  `;

  calendarGrid.appendChild(cell);

}

const cells = calendarGrid.querySelectorAll(".event-calendar-day");

let day = 1;

for (let i = firstDay; i < totalCells; i++) {

  const cell = cells[i];

  cell.classList.remove("empty");

  cell.dataset.day = day;

  const currentDay = day;

cell.querySelector(".event-calendar-day-number").textContent = currentDay;

  /* ---------- Mobile Day Click ---------- */

  cell.addEventListener("click", () => {

  selectedDay = currentDay;

  drawCalendar(gameFilter.value);

  showMobileEvents(currentDay);

});


  /* ----------------------------------------
     HIGHLIGHT TODAY
  ---------------------------------------- */

  const today = new Date();

  cell.classList.remove("today");
  cell.classList.remove("selected");


  if (
    today.getFullYear() === displayYear &&
    today.getMonth() === monthIndex &&
    today.getDate() === day
  ) {

    cell.classList.add("today");

  }

  if (selectedDay === day) {

  cell.classList.add("selected");

}


  day++;

}

    renderEvents(selectedGame);

  }

  /* ----------------------------------------
     RENDER EVENTS
  ---------------------------------------- */

  function renderEvents(selectedGame) {

    mobileList.innerHTML = "";

    events.forEach(event => {

      const date = new Date(event.date);

      if (isNaN(date)) return;

      if (date.getMonth() !== monthIndex) return;

      if (date.getFullYear() !== displayYear) return;

      if (
        selectedGame !== "all-games" &&
        event.game !== selectedGame
      ) return;

      const day = date.getDate();

      const cell = calendarGrid.querySelector(
        `[data-day="${day}"]`
      );

      if (!cell) return;

/* ---------- Event Dots ---------- */

let dots = cell.querySelector(".event-dots");

if (!dots) {

  dots = document.createElement("div");

  dots.className = "event-dots";

  cell.querySelector(".event-calendar-day-number")
      .after(dots);

}

const totalDots = dots.children.length;

if (totalDots < 3) {

  const dot = document.createElement("div");

  dot.className = "event-dot";

  dots.appendChild(dot);

}

      /* ---------- Desktop Card ---------- */

      const card = document.createElement("div");

      card.className = "event-card";

      card.style.background = event.color;

      card.innerHTML = `
        <div class="event-card-title">
          ${event.title}
        </div>

        <div class="event-card-time">
          ${event.time}
        </div>
      `;

      card.addEventListener("click", () => {

  const modal = document.getElementById("event-modal");

  document.getElementById("modal-title").textContent =
    event.title;

  document.getElementById("modal-game").textContent =
    event.game;

  document.getElementById("modal-date").textContent =
    `${displayMonth} ${day}, ${displayYear}`;

  document.getElementById("modal-time").textContent =
    event.time;

  document.getElementById("modal-description").innerHTML =
    event.description || "";

  const image = document.getElementById("modal-image");

  if(event.image){

    image.src = event.image;

    image.style.display = "block";

  }else{

    image.style.display = "none";

  }

  const registerButton =
    document.getElementById("modal-register");

  if(event.registration_url){

    registerButton.href = event.registration_url;

    registerButton.style.display = "inline-flex";

  }else{

    registerButton.style.display = "none";

  }

  /* ----------------------------------------
   GOOGLE CALENDAR
---------------------------------------- */

const calendarButton =
  document.getElementById("modal-google-calendar");

const startDate = new Date(event.date);

const endDate = new Date(startDate);

endDate.setDate(endDate.getDate() + 1);

const formatDate = (date) => {

  return date.toISOString().slice(0,10).replace(/-/g,"");

};

const calendarUrl =
  "https://calendar.google.com/calendar/render?action=TEMPLATE"
  + "&text=" + encodeURIComponent(event.title)
  + "&dates=" + formatDate(startDate) + "/" + formatDate(endDate)
  + "&details=" + encodeURIComponent(event.description || "");

calendarButton.href = calendarUrl;

  modal.classList.add("active");

});

 const eventContainer = cell.querySelector(".event-calendar-events");

const existingEvents = eventContainer.querySelectorAll(".event-card");


if (existingEvents.length < 2) {

  eventContainer.appendChild(card);

} else {

 let more = eventContainer.querySelector(".more-events");

if (!more) {

  more = document.createElement("div");

  more.className = "more-events";

  eventContainer.appendChild(more);

}

const totalEvents = events.filter(event => {

  const date = new Date(event.date);

  return (
    date.getDate() === day &&
    date.getMonth() === monthIndex &&
    date.getFullYear() === displayYear &&
    (
      selectedGame === "all-games" ||
      event.game === selectedGame
    )
  );

}).length;

const hiddenCount = totalEvents - 2;

if (hiddenCount > 0) {

  more.textContent = `+${hiddenCount} more`;

  more.style.display = "block";

} else {

  more.style.display = "none";

}

more.onclick = () => {

  openDayEvents(day, selectedGame);

};

}

      /* ---------- Mobile ---------- */

  const mobile = document.createElement("div");

  mobile.className = "mobile-event";

  mobile.dataset.day = day;

 mobile.innerHTML = `

<div class="mobile-event-image">

  ${
    event.image
      ? `<img src="${event.image}" alt="${event.title}">`
      : `<div class="mobile-event-placeholder" style="background:${event.color};"></div>`
  }

</div>

<div class="mobile-event-info">

  <div class="mobile-event-title">
    ${event.title}
  </div>

  <div class="mobile-event-date">
    ${displayMonth} ${day}, ${displayYear}
  </div>

  <div class="mobile-event-time">
    ${event.time}
  </div>

</div>

`;

mobile.addEventListener("click", () => {

    card.click();

});

  mobileList.appendChild(mobile);



    });

  }

  function openDayEvents(day, selectedGame) {

  const dayEvents = events.filter(event => {

    const date = new Date(event.date);

    return (
      date.getDate() === day &&
      date.getMonth() === monthIndex &&
      date.getFullYear() === displayYear &&
      (
        selectedGame === "all-games" ||
        event.game === selectedGame
      )
    );

  });

  if (!dayEvents.length) return;

  let html = "";

  dayEvents.forEach(event => {

    html += `
      <div style="margin-bottom:24px;">

        <h3 style="margin-bottom:8px;">
          ${event.title}
        </h3>

        <div style="margin-bottom:6px;">
          📅 ${displayMonth} ${day}, ${displayYear}
        </div>

        <div style="margin-bottom:14px;">
          🕒 ${event.time}
        </div>

        ${event.description || ""}

        <hr style="margin:24px 0;">

      </div>
    `;

  });

  document.getElementById("modal-title").textContent =
    `${dayEvents.length} Events`;

  document.getElementById("modal-game").textContent = "";

  document.getElementById("modal-date").textContent = "";

  document.getElementById("modal-time").textContent = "";

  document.getElementById("modal-description").innerHTML = html;

  document.getElementById("modal-image").style.display = "none";

  document.getElementById("modal-register").style.display = "none";

  document.getElementById("event-modal").classList.add("active");

}

function showMobileEvents(day) {

  console.log("Selected Day:", day);

  const cards = mobileList.querySelectorAll(".mobile-event");

  cards.forEach(card => {

    console.log("Card Day:", card.dataset.day);

    if (Number(card.dataset.day) === day) {

      card.style.display = "flex";

    } else {

      card.style.display = "none";

    }

  });

}

  /* ----------------------------------------
     FILTER
  ---------------------------------------- */

 const today = new Date();

const currentEvents = events
  .map(event => new Date(event.date))
  .filter(date =>
    date.getMonth() === monthIndex &&
    date.getFullYear() === displayYear
  )
  .sort((a, b) => a - b);

const todayEvent = currentEvents.find(date =>
  date.getDate() === today.getDate() &&
  date.getMonth() === today.getMonth() &&
  date.getFullYear() === today.getFullYear()
);

if (todayEvent) {

  selectedDay = todayEvent.getDate();

} else {

  const upcoming = currentEvents.find(date => date >= today);

  if (upcoming) {

    selectedDay = upcoming.getDate();

  } else if (currentEvents.length) {

    selectedDay =
      currentEvents[currentEvents.length - 1].getDate();

  }

}

drawCalendar();

if (selectedDay !== null) {

  showMobileEvents(selectedDay);

}

  gameFilter.addEventListener("change", function(){

      drawCalendar(this.value);

  });

  /* ----------------------------------------
   MODAL
---------------------------------------- */

const modal = document.getElementById("event-modal");

const closeButton =
document.getElementById("event-modal-close");

const overlay =
document.querySelector(".event-modal-overlay");

closeButton.addEventListener("click", () => {

  modal.classList.remove("active");

});

overlay.addEventListener("click", () => {

  modal.classList.remove("active");

});

document.addEventListener("keydown", (e) => {

  if(e.key === "Escape"){

    modal.classList.remove("active");

  }

});

});

